import { Injectable, signal } from '@angular/core';

import { MONTH_ATTRIBUTIONS, MonthAttribution } from 'src/models/monthly-finance.model';

/** The query param that carries the reading between the Monthly P&L and the Transactions tab. */
export const MONTH_ATTRIBUTION_QUERY_PARAM = 'basis';

/** A value from the URL, or null when it is missing or not one we know. */
export function parseMonthAttribution(raw: unknown): MonthAttribution | null {
  return MONTH_ATTRIBUTIONS.includes(raw as MonthAttribution) ? raw as MonthAttribution : null;
}

/** Accrual is the default, so it stays out of the URL. */
export function monthAttributionQueryValue(value: MonthAttribution): MonthAttribution | null {
  return value === 'accrual' ? null : value;
}

/**
 * One reading for every finance page. Flipping it on the Monthly P&L also flips the
 * Overview tiles and a month opened in Transactions, so the numbers never disagree.
 */
@Injectable({ providedIn: 'root' })
export class MonthAttributionService {
  readonly value = signal<MonthAttribution>('accrual');
}
